import classNames from 'classnames';
import { useState } from 'react';

import ButtonLink from '../Button/ButtonLink';
import MarketoForm from '../MarketoForm';
import { Heading2, Paragraph } from '../Text';

import style from './news-letter-card-content.module.css';

enum FormPage {
  Form = 1,
  Success = 2,
}

export interface NewsLetterCardContentProps {
  description?: string;
  marketoFormId: null | string | undefined;
  successMessage: string | undefined;
  successUrl?: null | string;
  title: null | string | undefined;
  withSmallTitle?: boolean;
}

const NewsLetterCardContent = ({
  description,
  marketoFormId,
  successMessage,
  successUrl,
  title,
  withSmallTitle,
}: NewsLetterCardContentProps) => {
  const [formPage, setFormPage] = useState<FormPage>(FormPage.Form);

  const handleSuccess = () => {
    setFormPage(FormPage.Success);
  };

  return (
    <>
      {title && (
        <Heading2
          fontColor="turquoise"
          fontWeight={300}
          {...withSmallTitle
            ? {
              fontSize: 24,
            }
            : {
              fontSizeOverride: 38,
            }}
        >
          {title}
        </Heading2>
      )}

      <div className={style.formContainer}>
        <div
          className={classNames(
            style.formPage,
            {
              [style.previous]: formPage === FormPage.Success,
              [style.current]: formPage === FormPage.Form,
            },
          )}
        >
          {description && (
            <Paragraph
              className={style.description}
              fontSize={15}
            >
              {description}
            </Paragraph>
          )}

          <MarketoForm
            className={style.form}
            marketoFormId={marketoFormId}
            onSuccess={handleSuccess}
          />
        </div>

        <div
          className={classNames(
            style.formPage,
            style.formSuccess,
            {
              [style.current]: formPage === FormPage.Success,
              [style.next]: formPage === FormPage.Form,
            },
          )}
        >
          <Paragraph
            className={style.formSuccessMessage}
            fontSize={24}
          >
            {successMessage ?? 'Thank you for signing up!'}
          </Paragraph>

          {successUrl && (
            <ButtonLink
              linkFragment={{
                target: '_blank',
                title: 'Download',
                url: successUrl,
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default NewsLetterCardContent;
